export const ECOMMERCE_OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'ecommerce-overview',
};
export const ECOMMERCE_PERFORMANCE_ROUTE = {
    title: 'Performance',
    name: 'ecommerce-performance',
};
export const SHOPIFY_OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'shopify-overview',
};
export const SHOPIFY_PERFORMANCE_ROUTE = {
    title: 'Performance',
    name: 'shopify-performance',
};
export const INSURANCE_OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'insurance-overview',
};
export const INSURANCE_PERFORMANCE_ROUTE = {
    title: 'Performance',
    name: 'insurance-performance',
};
